import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { TooltipPosition } from '../tooltip-fixed-trigger/useTooltipPosition';
import classNames from 'clsx';
import styles from './tooltip.component.module.scss';
interface Props {
  readonly children: ReactNode;
  readonly className?: string;
  readonly fitContent?: boolean;
  readonly position: TooltipPosition;
}
const TooltipComponent = t0 => {
  const $ = _c(9);
  const {
    children,
    className,
    fitContent,
    position
  } = t0;
  const t1 = position === TooltipPosition.TOP;
  const t2 = position === TooltipPosition.LEFT;
  const t3 = position === TooltipPosition.RIGHT;
  let t4;
  if ($[0] !== className || $[1] !== fitContent || $[2] !== t1 || $[3] !== t2 || $[4] !== t3) {
    t4 = classNames(styles.tooltip, className, {
      [styles["tooltip__arrow-top"]]: t1,
      [styles["tooltip__arrow-left"]]: t2,
      [styles["tooltip__arrow-right"]]: t3,
      [styles.tooltip__fitContent]: fitContent
    });
    $[0] = className;
    $[1] = fitContent;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const textClassName = t4;
  let t5;
  if ($[6] !== children || $[7] !== textClassName) {
    t5 = <div className={textClassName}>{children}</div>;
    $[6] = children;
    $[7] = textClassName;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default TooltipComponent;